import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Ladro (manuale V1, rr. 3737-3745).
 *
 * Sono 5 mosse di tipo `class_special`, una per ciascuna delle 5 razze
 * standard. Il PG sceglie un archetipo in fase di creazione (passo 5,
 * manuale V1 r. 1926). La scelta è suggerita dalla razza ma NON vincolata:
 * un Ladro Nano può scegliere l'archetipo Halfling se preferisce.
 *
 * Ogni mossa di archetipo è referenziata dal `grantedMoveId` del rispettivo
 * `Archetype` in `ClassDefinition.archetypes`.
 */

const archetipoUmano: Move = {
  id: 'ladro.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'ladro',
  trigger: 'Quando declami conoscenze o discerni la realtà riguardo ad attività criminali',
  description: 'Prendi +1 al tiro.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'ladro.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'ladro',
  trigger:
    'Quando sfidi il pericolo lanciandoti in folli ed esagerate acrobazie (come atterrare da metri di altezza dopo aver fatto un doppio avvitamento carpiato)',
  description: 'Hai sempre +1 al tiro.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'ladro.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'ladro',
  trigger: 'Quando discerni la realtà',
  description:
    'Aggiungi «*Qual è la cosa più preziosa che posso prendere senza essere notato?*» alle domande della lista. Inoltre, ti basta una singola occhiata per definire con discreta approssimazione il valore di mercato di qualsiasi oggetto.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'ladro.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'ladro',
  trigger: "Quando attacchi con un'arma a distanza",
  description: 'Infliggi +2 danni.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'ladro.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'ladro',
  trigger: 'Quando infliggi danni con *Attacco Furtivo*',
  description: 'Infliggi +1 danni.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const ladroArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
